/* Stolen from here: https://github.com/epoberezkin/fast-deep-equal/blob/master/index.js */
export function objectEquals(a: any, b: any): boolean {
    if (a === b) {
        return true;
    }

    if ((a && b) && (typeof a === "object") && (typeof b === "object")) {
        const arrA = Array.isArray(a);
        const arrB = Array.isArray(b);
        let i;
        let length;
        let key;

        if (arrA && arrB) {
            length = a.length;
            if (length !== b.length) {
                return false;
            }
            for (i = length; i-- !== 0;) {
                if (!objectEquals(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }

        if (arrA !== arrB) {
            return false;
        }

        const dateA = a instanceof Date;
        const dateB = b instanceof Date;
        if (dateA !== dateB) {
            return false;
        }
        if (dateA && dateB) {
            return a.getTime() === b.getTime();
        }

        const regexpA = a instanceof RegExp;
        const regexpB = b instanceof RegExp;
        if (regexpA !== regexpB) {
            return false;
        }
        if (regexpA && regexpB) {
            return a.toString() === b.toString();
        }

        const keys = Object.keys(a);
        length = keys.length;

        if (length !== Object.keys(b).length) {
            return false;
        }

        for (i = length; i-- !== 0;) {
            if (!b.hasOwnProperty(keys[i])) {
                return false;
            }
        }

        for (i = length; i-- !== 0;) {
            key = keys[i];
            if (!objectEquals(a[key], b[key])) {
                return false;
            }
        }

        return true;
    }

    return a !== a && b !== b;
}
